import { parseLiquidJSON } from "@/utils/liquidJSON";
import register from "preact-custom-element";
import { useEffect } from "preact/hooks";
import { setSwiperPadding } from "@/utils/screen.js";
import { createRef } from "preact";

function SwiperCtn(props) {
  console.log("swiper ctn");
  const containerRef = createRef();

  useEffect(() => {
    console.log(containerRef);
    const containerList =
      containerRef.current.querySelectorAll("swiper-container");

    console.log("containerList", containerList);

    containerList.forEach((item) => {
      setSwiperPadding(item, props.mspace ?? 10, props.space ?? 24);
    });

    window.addEventListener("resize", () => {
      containerList.forEach((item) => {
        setSwiperPadding(item, props.mspace ?? 10, props.space ?? 24);
      });
    });
  }, []);

  return (
    <div className="w-full" ref={containerRef}>
      {props.content}
    </div>
  );
}

register(SwiperCtn, "swiper-ctn", []);
